import { render, staticRenderFns } from "./Wangeditor.vue?vue&type=template&id=35f99cd6&scoped=true&"
import script from "./Wangeditor.vue?vue&type=script&lang=js&"
export * from "./Wangeditor.vue?vue&type=script&lang=js&"
import style0 from "./Wangeditor.vue?vue&type=style&index=0&id=35f99cd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f99cd6",
  null
  
)

export default component.exports